import { type ConversationInventory } from '../../services/inventory-service';

export const getInventoryItemCategories = (
  inventory: ConversationInventory | undefined
): string[] => {
  if (!inventory) {
    return [];
  }

  return Object.entries(inventory)
    .filter(([key]) => {
      if (key === 'custom_service') {
        return (inventory.custom_service?.length ?? 0) > 0;
      }

      const section =
        inventory[
          key as Exclude<keyof ConversationInventory, 'custom_service'>
        ];

      return (section?.items?.length ?? 0) > 0;
    })
    .map(([key]) => key);
};
